import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateWithCompany } from '../company-state';
import { getCompanyState } from './feature.selector';

export const getSelectedCompany: MemoizedSelector<StateWithCompany, string> = createSelector(
  getCompanyState,
  (state) => state?.selected,
);
